import gql from 'graphql-tag';

export default gql`
  fragment invitationsFields on Invitation {
    id
    name
    role
    code
    expirationDate
    activationCount
  }
`;
